import { useBusinessModalContext as c } from "../../../../BusinessModalContext.js";
import { useCountData as r } from "../../../../hooks/useCountData.js";
import { MAX_BUSINESSES_SELECTED as o } from "../../../../reducer/businessModal.reducer.js";
const l = () => {
  const {
    translations: s
  } = c(), {
    totalSelectedBusinesses: t
  } = r(), n = Math.min(t, o), e = t > o ? "+" : "", u = t > 0 ? ` (${n}${e})` : "";
  return `${s.confirm}${u}`;
};
export {
  l as useGetConfirmText
};
